import Cookies from 'js-cookie';
import { creatMultidimensionalArray } from '../assets/js/creatArr.js';
import { getAllOrgan } from '../graphql/graphql.js';

/**
 * 封装获取部门列表的接口
 * @param {Object} self 传入带有apollo的对象， 比如this
 */
export function getOrganList(self) {
    let supplier = Cookies.getJSON('USER-INFO') && Cookies.getJSON('USER-INFO').supplierNo;
    let clique = Cookies.getJSON('cliqueNo').toString();
    return self.$apollo.query({
        query: getAllOrgan,
        variables: {
            supplierNo: supplier,
            cliqueNo: clique
        },
        fetchPolicy: 'network-only'
    }).then(res => {
        const data = res.data.getAllOrgan;
        if (data && data.data && data.code === 200) {
            let parentData = [];
            let finalARr = [];
            for (let i = 5;i > 0;i -= 1) {
                if (data.data[i.toString()] && data.data[i.toString()].length) {
                    parentData = creatMultidimensionalArray(
                        data.data[i.toString()],
                        parentData,
                        'parentNo',
                        'organName',
                        'organNo'
                    );
                } else {
                    continue;
                }
            }
            parentData.forEach(ele => {
                let organNo, organName, children, value, label;
                ({organNo: value, organName: label, children} = ele);
                finalARr.push({
                    value,
                    label,
                    children
                });
            });
            return finalARr;
        } else {
            self.$setNotice('部门列表获取失败');
        }
    });
}



// WEBPACK FOOTER //
// ./src/graphql/query.js